type FormatPhoneNumberResult =
  | { error: false; errorMessage: null; data: string }
  | { error: true; errorMessage: string; data: null };

export const formatPhoneNumber = (input: string): FormatPhoneNumberResult => {
  if (!input || typeof input !== "string") {
    return {
      error: true,
      errorMessage: "Invalid input: phone number must be a non-empty string",
      data: null,
    };
  }

  // Remove all non-digit characters
  let digits = input.replace(/\D/g, "");

  if (digits.length < 9) {
    return {
      error: true,
      errorMessage:
        "Invalid input: too few digits to be a valid UK phone number",
      data: null,
    };
  }

  // Handle different UK number formats
  if (digits.startsWith("0044")) {
    digits = digits.slice(4); // remove leading 0044
  } else if (digits.startsWith("44")) {
    digits = digits.slice(2); // remove leading 44
  } else if (digits.startsWith("0")) {
    digits = digits.slice(1); // remove leading 0
  }

  const formatted = `+44${digits}`;

  // Validate against expected UK mobile/landline format
  if (!/^\+44\d{9,10}$/.test(formatted)) {
    return {
      error: true,
      errorMessage: `Unexpected format: "${input}" could not be normalized to a valid UK phone number`,
      data: null,
    };
  }

  return {
    error: false,
    errorMessage: null,
    data: formatted,
  };
};
